export type Params = { [key: string]: string | null };

export type Nullable<T> = {
    [P in keyof T]: T[P] | null;
};

function _parseSearch(query: string): Params {
    return query
        .split('&')
        .map((e) => e.split('='))
        .reduce((params: Params, param) => {
            params[param[0]] = param[1];
            return params;
        }, {});
}

export default function parseUrl(urlStr: string) {
    const splitUrl = urlStr.split('?');
    const reqUrl = splitUrl[0];
    const params = _parseSearch(splitUrl[1]);
    return { url: reqUrl, params };
}
